// extracted by mini-css-extract-plugin
export default {"clientContainer":"Client_clientContainer__GnViV","slider":"Client_slider__KCchi"};